export default {
    palette: {
        primary: {
            main: 'rgb(21, 40, 120)'
        },
        secondary: {
            main: '#f39200'
        }
    },
    typography: {
        fontFamily: '"Source Sans Pro", arial, sans-serif;!important',
        h4: {
            fontFamily: '"Muli", arial, sans-serif;!important',
            textTransform: 'uppercase',
            fontWeight: 400
        },
        h5: {
            fontFamily: '"Muli", arial, sans-serif;!important',
            textTransform: 'uppercase',
            fontWeight: 400
        },
        h6: {
            fontWeight: 400
        }
    },
    overrides: {
        MuiButton: {
            root: {
                fontWeight: 700,
                background: 'rgb(21, 40, 120)',
                color: '#fff',
                transition: 'none'
            },
            outlinedPrimary: {
                color: '#fff'
            },
            textPrimary: {
                color: '#fff'
            }
        }
    }
};
